/**
 * Accordion
 */

export default function HWY_Accordion() {
    const selectors = {
        src: ".accordion-src",
        dist: ".accordion-dist",
        accordions: ".accordions",
        accordion: ".single-accordion",
        showAll: ".faq-intro-text",
        faq: ".hwy__faq"
    };

    this.init = () => {
        if (jQuery(selectors.accordion).length) {
            jQuery(selectors.accordion).each(function () {
                const el = jQuery(this);
                el.find(selectors.dist).slideUp(400);
            })
        }
        jQuery(selectors.src).on("click", function (e) {

            jQuery(this).closest(selectors.accordion).siblings().each(function () {
                if (jQuery(this).find(selectors.src).hasClass('open')) {
                    jQuery(this).find(selectors.dist).slideUp(400);
                    jQuery(this).find(selectors.src).toggleClass('open');
                }
            });

            if (jQuery(this).hasClass('open')) {
                jQuery(this).closest(selectors.accordion).find(selectors.dist).slideUp(400);
                jQuery(this).toggleClass('open');
            }
            else {
                jQuery(this).closest(selectors.accordion).find(selectors.dist).slideDown(400);
                jQuery(this).toggleClass('open');
            }

        });

        // jQuery(selectors.showAll).on("click", function(e) {
        // 	jQuery(this).closest(selectors.faq).find(selectors.accordion).siblings().each(function(){
        // 		if(!jQuery(this).find(selectors.src).hasClass('open')){
        // 			jQuery(this).find(selectors.dist).slideDown(400);
        // 			jQuery(this).find(selectors.src).toggleClass('open');
        // 		}
        // 	});
        // });

    };
}
